// breakpoints.ts
export const breakpoints = {
  desktop: 1272,
  laptop: 960,
  tablet: 648,
  mobile: 480,
};
